/* eslint-disable */
/* @ts-nocheck */

import { AsyncRestClient } from "@/infrastructure/backend/async/AsyncRestClient";
import { newDate } from "@/infrastructure/functional/datetimehelper";
import { geoConvertLib } from "./geo-point-calculations";
import { loadGeoRevier } from "../geo-data/load-revier";
import { AppLanguage } from "@/infrastructure/backend/AppLanguage";
import { UserProfile } from "@/infrastructure/backend/userProfile";

// row.formularFeldname === "KoordinateX"
export async function lv95PointInPolygon(revierNumber: any, longitude: number , latitude: number , produkt: string | undefined) :Promise<boolean> {
    try {

        var revierPolygon = await loadGeoRevier(revierNumber , produkt , "jagdrevier" )
        if( !revierPolygon) return false
    
        const insidePolygon = loaclPointInPolygon(longitude, latitude, revierPolygon)
        return insidePolygon

    } catch(e) {
        return false
    }  
}

export const geoUtilities = (function () {
    // function getBoundingBox(data: any, isMultiPolygon: boolean) {
    //     let yMin = 10000
    //     let xMin = 10000

    //     let yMax = -10000
    //     let xMax = -10000

    //     if (isMultiPolygon) {
    //         for (let i = 0; i < data.features.length; i++) {
    //             for (let j = 0; j < data.features[i].geometry.coordinates.length; j++) {
    //                 for (let x = 0; x < data.features[i].geometry.coordinates[j][0].length; x++) {
    //                     var point = data.features[i].geometry.coordinates[j][0][x];

    //                     if (point[0] < yMin) {
    //                         yMin = point[0]
    //                     }
    //                     if (point[0] > yMax) {
    //                         yMax = point[0]
    //                     }

    //                     if (point[1] < xMin) {
    //                         xMin = point[1]
    //                     }
    //                     if (point[1] > xMax) {
    //                         xMax = point[1]
    //                     }
    //                 }
    //             }
    //         }
    //     } else {
    //         for (let i = 0; i < data.features.length; i++) {
    //             for (let j = 0; j < data.features[i].geometry.coordinates.length; j++) {
    //                 for (let x = 0; x < data.features[i].geometry.coordinates[j].length; x++) {
    //                     const point = data.features[i].geometry.coordinates[j][x];

    //                     if (point[0] < yMin) {
    //                         yMin = point[0]
    //                     }
    //                     if (point[0] > yMax) {
    //                         yMax = point[0]
    //                     }

    //                     if (point[1] < xMin) {
    //                         xMin = point[1]
    //                     }
    //                     if (point[1] > xMax) {
    //                         xMax = point[1]
    //                     }
    //                 }
    //             }
    //         }

    //     }

    //     return {
    //         southWestLat: xMin,
    //         southWestLong: yMin,
    //         northEastLat: xMax,
    //         northEastLong: yMax
    //     }
    // }



    function pointInPolygon(x: number, y: number, data: any) {
        return loaclPointInPolygon(x, y, data);     
    }

    function centerInPolygon(data: any) {    

        const point = polygonLib.centroid(data.features[0].geometry)
        const p1 = { 
            geometry: {
                coordinates: [2]
            }
        }
        p1.geometry.coordinates[0] = point[0]
        p1.geometry.coordinates[1] = point[1]


     

        return p1
    }





    return {
        //getBoundingBox,
        pointInPolygon,
        centerInPolygon
    }
})();




// **********************************************************
function loaclPointInPolygon(x: number, y: number, data: any) {
    const point = geoConvertLib.Lv95ToWgs(y, x);
    x = point.lng;
    y = point.lat;
    const pt = [x,y]
    
    for(let polyGons = 0; polyGons <  data.features[0].geometry.coordinates.length; polyGons++) {
        const isInsideOrNot = polygonLib.polygon( data.features[0].geometry.coordinates[0], pt )
        if ( isInsideOrNot ) return true;
    
    }

    return false;
}

export const polygonLib = (function () {

    //****************************** seyuf/polygon-center-calculator.js **start**************************/

    function area(poly: any){
    var s = 0.0;
    var ring = poly.coordinates[0][0];
    for(let i= 0; i < (ring.length-1); i++){
      s += (ring[i][0] * ring[i+1][1] - ring[i+1][0] * ring[i][1]);
    }
    return 0.5 *s;
  }

  function centroid(poly: any){
    var c = [0,0];
    var ring = poly.coordinates[0][0];
    for(let i= 0; i < (ring.length-1); i++){
      c[0] += (ring[i][0] + ring[i+1][0]) * (ring[i][0]*ring[i+1][1] - ring[i+1][0]*ring[i][1]);
      c[1] += (ring[i][1] + ring[i+1][1]) * (ring[i][0]*ring[i+1][1] - ring[i+1][0]*ring[i][1]);
    }
    var a = area(poly);
    c[0] /= a *6;
    c[1] /= a*6;
    return c;
  }

  //****************************** seyuf/polygon-center-calculator.js **end**************************/


 //****************************** moussagigawatt point-in-geopolygon **start**************************/



function scalar(x: any, y: any) {
    return (x[0] * y[0] + x[1] * y[1]);
}

function det(x: any, y: any) {
    return (x[0] * y[1] - x[1] * y[0]);
}

function circular(l: any, i: any) {
    if ((i > 0) && (i <= l - 2)) {
        return ([i - 1, i + 1]);
    } else if (i == 0) {
        return ([l - 2, 1]);
    } else if (i == l - 1) {
        return ([l - 2, 1]);
    }
    
}

function unit(v: any) {
    var sr = Math.sqrt(scalar(v, v));
    return ([v[0] / sr, v[1] / sr]);
}

function vector(x: any, y: any) {
    return ([y[0] - x[0], y[1] - x[1]]);
}

function sum(a: any, b: any) {
    return ([a[0] + b[0], a[1] + b[1]]);
}

function vct_max(jad: any, point: any, p: any, saver: any) {
    var s;
    var tsd = scalar(vector(point, p), vector(point, p));
    saver[0] = vector(jad[0][0], jad[0][1]);
    var masafa = scalar(saver[0], saver[0]);
    var pid = 1;
    var vs = [0, 0];
    for (var i = 1; i < jad[0].length - 1; i++) {
        vs = sum(vs, saver[i - 1]);
        saver[saver.length] = vector(jad[0][i], jad[0][i + 1]);
        s = scalar(vs, vs);
        if (s > masafa) {
            pid = i;
            masafa = s;
        }
    }
    if (tsd <= masafa) {
        return pid;
    } else {
        return -1;
    }
}

function filter(jad: any, point: any, p: any, saver: any) {
    var b;
    var s;
    var tsd = scalar(vector(point, p), vector(point, jad[0][1]));
    saver[0] = vector(jad[0][0], jad[0][1]);
    var masafa = scalar(saver[0], saver[0]);
    var vs = [0, 0];
    for (var i = 1; i < jad[0].length - 1; i++) {
        vs = sum(vs, saver[i - 1]);
        saver[saver.length] = vector(jad[0][i], jad[0][i + 1]);
        s = scalar(vector(point, p), unit(vs));
        if (s > tsd) {
            tsd = s;
            if (scalar(vector(point, p), vs) <= scalar(vs, vs)) {
                b = true;
            } else {
                b = false;
            }
        }
    }
    return b;
}

function distance(jad: any, p: any) {
    var v = vector(jad, p);
    return scalar(v, v);
}

function sort_feacher(GeoJSON: any, p: any) {
    var sorted = [];
    for (var i = 0; i < GeoJSON.features.length; i++) {
        if (GeoJSON.features[i].geometry.type == 'Polygon') {
            sorted[i] = {
                distance: distance(GeoJSON.features[i].geometry.coordinates[0][0], p),
                id: i
            };
        } else {
            sorted[i] = {
                distance: distance(GeoJSON.features[i].geometry.coordinates[0][0][0], p),
                id: i
            };
        }
    }
    return sorted.sort(function(a, b) {
        return (a.distance - b.distance);
    });
}

function normal_ref_vector(jad: any, mix: any) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var n = unit(vector(jad[0][mix], jad[0][circular(jad[0].length, mix)[1]]));

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (scalar([n[1], -n[0]], vector(jad[0][mix], jad[0][circular(jad[0].length, mix)[0]])) <= 0) {
        return ([n[1], -n[0]]);
    } else {
        return ([-n[1], n[0]]);
    }
}

function normal(v: any) {
    return [-v[1], v[0]];
}

function delation(v: any, k: any) {
    return [v[0] * k, v[1] * k]
}


function normal_vector(jad: any, i: any, mx: any, mix: any) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var d = vector(jad[0][mix], jad[0][circular(jad[0].length, mix)[1]]);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var f = vector(jad[0][i], jad[0][circular(jad[0].length, i)[1]]);
    var cosine = scalar(d, f);
    var sine = det(d, f);
    var r = [(mx[0] * cosine - mx[1] * sine), (mx[0] * sine + mx[1] * cosine)];
    return r;
}

function normalv(jad: any, i: any, mx: any, mix: any) {
    var cosine = scalar(unit(mix), unit(i));
    var sine = det(unit(mix), unit(i));
    return ([(mx[0] * cosine - mx[1] * sine), (mx[0] * sine + mx[1] * cosine)]);
}

function sort_vector(jad: any, p: any, saver: any) {
    var srt = [];
    var v = [];
    var d = [];
    var viv;
    var bln = true;
    var u = 1000000;
    var f
    srt[0] = [u, -1];
    for (var i = 0; i < jad[0].length - 1; i++) {
        d = saver[i];
        v = vector(jad[0][i], p);
        if (scalar(v, d) >= 0) {
            var ti = (newDate()).getTime();
            if (scalar(v, d) <= scalar(d, d)) {
                f = det(v, unit(d));
                if (Math.pow(f, 2) <= srt[0][0]) {
                    srt[0][0] = Math.pow(f, 2);
                    srt[0][1] = i;
                }
                bln = false;
            } else {
                bln = true;
            }
        } else {
            if (bln) {
                if (scalar(v, v) <= u) {
                    u = scalar(v, v);
                    viv = i;
                }
            }
        }
    }
    srt[1] = [];
    srt[1][0] = u;
    srt[1][1] = viv ?? 0;
    return srt;
}

    function polygon(jad: any, p: any) {
        var intern = false;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var saver = [];
        var mx = [];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
        var threshold = vct_max(jad, jad[0][0], p, saver);
        if (threshold != -1) {
            mx = normal_ref_vector(jad, threshold);
            var ti = (newDate()).getTime();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
            var tbs = sort_vector(jad, p, saver);
            if (tbs[0][0] <= tbs[1][0]) {
                if (tbs[0][0] <= tbs[1][0]) {
                    if (scalar(normal_vector(jad, tbs[0][1], mx, threshold), vector(jad[0][tbs[0][1]], p)) <= 0) {
                        intern = true;
                    }
                }
            } else {
                var v = vector(jad[0][tbs[1][1]], p);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

                if (Math.abs(det(v, unit(saver[tbs[1][1]]))) > Math.abs(det(v, unit(saver[((tbs[1][1] > 0) ? tbs[1][1] - 1 : saver.length - 1)])))) {
                    if (scalar(normal_vector(jad, tbs[1][1], mx, threshold), v) <= 0) {
                        intern = true;
                    }
                } else {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (scalar(normal_vector(jad, circular(jad[0].length, tbs[1][1])[0], mx, threshold), v) <= 0) {
                        intern = true;
                    }
                }
            }
        }
        return intern;
    }
    function feature(GeoJSON: any, p: any) {
        var a;
        var sort = sort_feacher(GeoJSON, p);
        for (var i = 0; i < sort.length; i++) {
            if (GeoJSON.features[sort[i].id].geometry.type == 'Polygon') {
                if (polygon(GeoJSON.features[sort[i].id].geometry.coordinates, p)) {
                    a = {
                        id: sort[i].id,
                        properties: GeoJSON.features[sort[i].id].properties,
                        type: 'Polygon'
                    };
                    break;
                }
            } else {
                for (var j = 0; j < GeoJSON.features[sort[i].id].geometry.coordinates.length; j++) {
                    if (polygon(GeoJSON.features[sort[i].id].geometry.coordinates[j], p)) {
                        a = {
                            id: sort[i].id,
                            properties: GeoJSON.features[sort[i].id].properties,
                            type: 'MultiPolygon',
                            polygon: j
                        };
                        break;
                    }
                }
                if (a) {
                    break;
                }
            }
        }
        if (a) {
            return a;
        } else {
            return -1;
        }
    }

 
 //****************************** moussagigawatt point-in-geopolygon **end**************************/



  return {
    centroid,
    polygon
  }

}) ()

